import { FC, JSX, useState } from "react";
import { Button, Flex, TextField, Text, Box, Checkbox } from "@radix-ui/themes";
import { useRegister } from "../../hooks/useRegister";
import { RegisterFormProps } from "./RegisterForm.types";
import { formFields } from "./RegisterForm.fields";
import Alert from "@/components/Alert/Alert";

const RegisterForm: FC = (): JSX.Element => {
  const { handleRegister, loading, error } = useRegister();

  const [values, setValues] = useState<RegisterFormProps>({
    email: "",
    password: "",
    passwordConfirm: "",
    terms: false,
  });

  const setNewRegisterValue = (targetName: string, value: string | boolean) => {
    return setValues((prev: RegisterFormProps) => ({
      ...prev,
      [targetName]: value,
    }));
  };

  return (
    <Box>
      <Flex direction="column" gap="4">
        {formFields.map((field) => (
          <Flex key={field.id} direction="column" gap="1">
            <Flex justify="between" align="end">
              <Text as="label" size="2">
                {field.label}
              </Text>
            </Flex>
            {typeof values[field.value as keyof RegisterFormProps] !==
              "boolean" && (
              <TextField.Root
                size="3"
                type={field.type}
                value={
                  values[field.value as keyof RegisterFormProps] as
                    | string
                    | number
                    | undefined
                }
                onChange={(e) => {
                  setNewRegisterValue(field.id, e.target.value);
                }}
              />
            )}
          </Flex>
        ))}
        <Text as="label" size="2">
          <Flex gap="2">
            <Checkbox
              onClick={() => setNewRegisterValue("terms", !values.terms)}
              checked={values.terms}
            />
            I agree to the Terms and Conditions and Privacy Policy and confirm
            that you are at least 13 years old.
          </Flex>
        </Text>
        {error && error.message && <Alert>{error.message}</Alert>}
        <Button
          disabled={!values.terms || loading}
          size="3"
          onClick={() => {
            if (!loading) {
              handleRegister(values);
            }
          }}
        >
          {loading ? "Signing you in .." : "Create an account"}
        </Button>
      </Flex>
    </Box>
  );
};

export default RegisterForm;
